import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';
import Navbar from './Components/Navbar';
import Home from './Components/Home';
import Model from './Components/Model';
import Products from './Components/Products';
import Login from './Profile/Login';
import Signin from './Profile/Signin';
import Bag from './Profile/Bag';
import Address from './Profile/Address';
import OrderPage from './Components/OrderPage';
import PaymentPage from './Components/PaymentPage';
import OrderConfirmed from './Components/OrderConfimered';
import TrackingPage from './Components/TrackingPage';
import OrderCancelPage from './Components/OrderCanclePage';
import OrderReturnPage from './Components/OrderReturnPage';
import RisingProducts from './Components/Rising Star/RisingStarProducts';
import OffersProducts from './Components/Special Offers/OffersProducts';
import ShirtProduct from './Components/Men/Shirt';
import TshirtProduct from './Components/Men/Tshirt';
import JeansProducts from './Components/Men/Jeans';
import ShoesProducts from './Components/Men/Shoes';
import Accessories from './Components/Men/Accessories';
import Ethnic from './Components/Women/Ethnic';
import Western from './Components/Women/Western';
import Footer from './Components/Footer';
import Sports from './Components/Women/Sports';
import AccessoriesWomen from './Components/Women/Accessories';
import BoysClothing from './Components/Kids/BoysClothing';
import GirlsClothing from './Components/Kids/GirlsClothing';
import Infants from './Components/Kids/Infants';
import BFootwear from './Components/Kids/BoysFootwear';
import GFootwear from './Components/Kids/GirlsFootwear';
import BedLinen from './Components/Home/BedLinen';
import Flooring from './Components/Home/Flooring';
import Bath from './Components/Home/Bath';
import HomeDecor from './Components/Home/HomeDecor';
import Kitchen from './Components/Home/Kitchen';
import MakeUp from './Components/Beauty/MakeUp';
import Skincare from './Components/Beauty/Skincare';
import Haircare from './Components/Beauty/Haircare';
import Frangrances from './Components/Beauty/Frangrances';
import MenGrooming from './Components/Beauty/MensGrooming';
import CouponsPage from './Components/Coupan/Coupan';
import ContactSection from './Components/ContactUs';
import Privacy from './Components/PrivacyPolicy';
import DealsSection from './Components/Grand Global Brand/BrandProducts';
import ShopFavorites from './Components/Productsec';
import { TopPicks } from './Components/Grand Global Brand/TopPicks';
import { CrazyDeals } from './Components/Grand Global Brand/CrazyDeals';
import { Prodforyou } from './Components/Grand Global Brand/Productsforyou';
import Categories from './Components/Categories/Categories';
import SubCategory from './Components/Sub Category/Subcategory';
import { Wishlist } from './Components/Wishlist/Wishlist';
import Search from './Components/search';
import LoginModal from './Profile/loginmodel';
import ProductReview from './Components/ReviewPage';
import Contactsupplier from './Components/contactsupplier';
import ChatPage from './Components/chat/chatPage';
import ProfilePage from './Profile/Profile Section/ProfilePage';
import ProfileInfo from './Profile/Profile Section/Profileinfo';
import ProfileSidebar from './Profile/Profile Section/ProfileSidebar';
import MyAddress from './Profile/Profile Section/Myaddress';
import Notifications from './Profile/Profile Section/notifications';
import ReferPage from './Components/Referafrnd';
import ReferralRewards from './Components/ReferRewards';
import OrderDetails from './Components/OrderDetails';
import CancelOrder from './Components/OrderCancle';
import OrderCancelled from './Components/OrderCancelled';
import NotificationDropdown from './Components/Notification';
import Dummy from './Components/Dummy';


import About from './Components/About';
import Faq from './Faq';
import Policy_footer from './Policy_footer';
// import Story from './Story';
import Security from './Security';
import Shipping_policy from './Shipping_policy';
import CancelPolicy from './CancelPolicy';
import Refressal from './Refressal';
import Contact_footer from './Contact_footer';
import Home_story from './Home_story';
import TermsOfUsePage from './Termsofuse';
import PaymentsPage from './Paymentspage';
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
<div>
  <Router>
  <Navbar/>
    <Routes>
      <Route exact path='/' element={<Home/>}/>
      {/* <Route path='/Navbar' element={<Navbar/>}/> */}
      <Route path='/products' element={<Products/>}/>
      <Route path='/BrandProducts' element={< DealsSection />}/>
      <Route path='/RisingProducts' element={< RisingProducts />}/>
      <Route path='/OffersProducts' element={< OffersProducts />}/>
      <Route path='/Productsec' element={<ShopFavorites/>}/>
      <Route path="/model/:product_id" element={<Model />} />
      <Route path='/login' element={<Login/>}/>
      <Route path='loginmodal' element={<LoginModal />} />
      <Route path='/signin' element={<Signin/>}/>
      <Route path='/bag' element={<Bag/>}/>
      <Route path='/address' element={<Address/>}/>
      <Route path='/order/:id' element={<OrderPage/>}/>
      <Route path='/order' element={<OrderPage/>}/>
      <Route path='/payment' element={<PaymentPage/>}/>
      <Route path='/order-confirmed' element={<OrderConfirmed/>}/>
      <Route path='/track-order/:orderId/:productId' element={<TrackingPage/>}/>
      <Route path='/order-cancel' element={<OrderCancelPage/>}/>
      <Route path='/order-return/:orderId/:productId' element={<OrderReturnPage/>}/>
      <Route path='/Coupan' element={< CouponsPage/>} />
      <Route path='/ContactUs' element={< ContactSection/>} />
      <Route path='/PrivacyPolicy' element={< Privacy/>} />
      <Route path='/TopPicks' element={< TopPicks/>} />
      <Route path='/CrazyDeals' element={< CrazyDeals/>} />
      <Route path='/Prodforyou' element={<Prodforyou/>} />
      <Route path='/Categories' element={<Categories />}/>
      <Route path='/subcategory/:id' element={< SubCategory/>} />
      <Route path='/Wishlist' element={<Wishlist/>} />
      <Route path="/search" element={<Search />} />
      <Route path="/ProductReview/:user_id/:order_id/:product_id" element={<ProductReview />} />
      <Route path="/contact-supplier/:productId/:sellerId" element={< Contactsupplier/>} />
      <Route path="/chatpage" element={<ChatPage/>} />
      <Route path="/Notification" element={<NotificationDropdown /> } />
      <Route path="/dummy" element={<Dummy /> } />

      <Route path="/Profilepage" element={<ProfilePage />} />
      <Route path="/Profilinfo" element={<ProfileInfo />} />
      <Route path="/Profilesidebar" element={<ProfileSidebar />} />
      <Route path="/myaddress" element={<MyAddress />} />
      <Route path="/mynotification" element={<Notifications />} />

      <Route path="/Referfrnd" element={<ReferPage />} />
      <Route path="/ReferReward" element={< ReferralRewards/>} />

      <Route path="/Orderdetails/:orderId/:productId" element={< OrderDetails/>} />
      <Route path="/order-cancel/:orderId/:productId" element={<CancelOrder />} />

      <Route path="/order-cancelled/:orderId/:productId" element={<OrderCancelled />} />


      

      {/* Men Products */}
      <Route path='/Men/Shirts' element={<ShirtProduct/>}/>
      <Route path='/Men/Tshirt' element={<TshirtProduct/>}/>
      <Route path='/Men/Jeans' element={<JeansProducts/>}/>
      <Route path='/Men/Shoes' element={<ShoesProducts/>}/>
      <Route path='/Men/Accessories' element={<Accessories/>}/>

      {/* Women Products */}
      <Route path='/Women/Ethnic' element={<Ethnic/>} />
      <Route path='/Women/Western' element={<Western/>} />
      <Route path='/Women/Footwear' element={<Footer/>} />
      <Route path='/Women/Sports' element={<Sports/>} />
      <Route path='/Women/Accessories' element={<AccessoriesWomen/>} />

      {/* Kids Products */}
      <Route path='/Kids/BClothing' element={<BoysClothing />} />
      <Route path='/Kids/GClothing' element={<GirlsClothing />} />
      <Route path='/Kids/Infants' element={<Infants />} />
      <Route path='/Kids/BFootwear' element={<BFootwear />} />
      <Route path='/Kids/GFootwear' element={< GFootwear />} />

      {/* Home Products */}
      <Route path='/Home/BedLinen' element={<BedLinen />} />
      <Route path='/Home/Flooring' element={<Flooring />} />
      <Route path='/Home/Bath' element={<Bath />} />
      <Route path='/Home/HomeDecor' element={<HomeDecor />} />
      <Route path='/Home/Kitchen' element={<Kitchen />} />

      {/* Beauty Products */}
      <Route path='/Beauty/Makeup' element={<MakeUp />} />
      <Route path='/Beauty/Skincare' element={<Skincare />} />
      <Route path='/Beauty/Haircare' element={<Haircare />} />
      <Route path='/Beauty/Fragrances' element={<Frangrances />} />
      <Route path='/Beauty/Grooming' element={<MenGrooming />} />


      {/* ABOUT PAGE  */}
      <Route path='/about' element={<About/>}/>



      <Route path="/faq" element={<Faq/>}/>

      <Route path="/policy_footer" element={<Policy_footer/>}/>

      {/* <Route path='/story' element={<Story/>}/> */}

      <Route path='/security' element={<Security/>}/>

      <Route path="/shipping_policy" element={<Shipping_policy/>}/>

      <Route path="/cancel_policy" element={<CancelPolicy/>}/>

      <Route path='/refresal' element={<Refressal/>}/>

      <Route path='/contact-footer' element={<Contact_footer/>}/>

      <Route path='/story' element={<Home_story/>}/>

      <Route path='/TermsOfUse' element={<TermsOfUsePage/>}/>

      <Route path='/PaymentsPage' element={<PaymentsPage/>}/>

    </Routes>

  </Router>
  {/* <ToastContainer /> */}
</div>
  );
}

export default App;
